'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var notistack = require('notistack');
var styles = require('@mui/material/styles');
var MuiStylesProvider = require('@mui/styles/StylesProvider');
var Grow = require('@mui/material/Grow');
var components_BaseStyle_index = require('../BaseStyle/index.js');
var components_Snackbar_index = require('../Snackbar/index.js');
var constants_themes = require('../../constants/themes.js');
require('../../tslib.es6-929adab5.js');
require('../Title2/index.js');
require('../SvgIcon/index.js');
require('../../constants/properties.js');
require('../ButtonText/index.js');
require('../../exclamation-mark-8535f548.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var MuiStylesProvider__default = /*#__PURE__*/_interopDefaultLegacy(MuiStylesProvider);
var Grow__default = /*#__PURE__*/_interopDefaultLegacy(Grow);

var mui_theme = styles.createTheme({
    typography: {
        allVariants: {
            fontFamily: constants_themes.Font.PRIMARY,
        },
    },
    palette: {
        primary: {
            main: constants_themes.Color.INDIGO_600,
        },
    },
});
var ThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    return (React__default["default"].createElement(styled.ThemeProvider, { theme: theme },
        React__default["default"].createElement(notistack.SnackbarProvider, { preventDuplicate: true, TransitionComponent: Grow__default["default"], anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, content: (function (key, _a) {
                var variant = _a.variant, text = _a.text, actionText = _a.actionText, onActionClick = _a.onActionClick;
                return (React__default["default"].createElement(components_Snackbar_index["default"], { id: key, variant: variant, text: text, actionText: actionText, onActionClick: onActionClick })
                // this needs to be casted since we're not using the same type signature as the library
                );
            }) },
            React__default["default"].createElement(MuiStylesProvider__default["default"], { injectFirst: true },
                React__default["default"].createElement(styles.StyledEngineProvider, { injectFirst: true },
                    React__default["default"].createElement(styles.ThemeProvider, { theme: mui_theme },
                        React__default["default"].createElement(components_BaseStyle_index["default"], null),
                        children))))));
};

exports["default"] = ThemeProvider;
